import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useIntl } from 'react-intl';

// MUI Components
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

// ==============================|| PWA UPDATE PROMPT ||============================== //

export default function PWAUpdatePrompt() {
  const intl = useIntl();
  const [showReload, setShowReload] = useState(false);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker
  } = useRegisterSW({
    onRegistered(registration) {
    },
    onRegisterError(error) {
    }
  });

  useEffect(() => {
    if (needRefresh) {
      setShowReload(true);
    }
  }, [needRefresh]);

  const handleClose = () => {
    setShowReload(false);
    setNeedRefresh(false);
  };

  const handleUpdate = async () => {
    await updateServiceWorker(true);
    // Reload the page to apply the new service worker
    window.location.reload();
  };

  return (
    <Snackbar
      open={showReload}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="info"
        variant="filled"
        sx={{ width: '100%' }}
        action={
          <Stack direction="row" spacing={1}>
            <Button color="inherit" size="small" onClick={handleClose}>
              {intl.formatMessage({ id: 'pwa.later' })}
            </Button>
            <Button color="inherit" size="small" variant="outlined" onClick={handleUpdate}>
              {intl.formatMessage({ id: 'pwa.updateNow' })}
            </Button>
          </Stack>
        }
      >
        {intl.formatMessage({ id: 'pwa.newVersionAvailable' })}
      </Alert>
    </Snackbar>
  );
}
